import * as types from "./types";
// import * as mutation_types from "./mutation_types";
import {
    Get,
    Post
} from "./api/methods";

export default {
    [types.A_GET_WARNING_AND_BAN_USER](context, payload) {
        return new Promise((resolve) => {
            Post({API_URL: `${context.rootState.API_URL}GetWarnings/Get?partnerKey=${payload}`})
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_GET_COUNTRIES](context) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Get(`${context.rootState.API_URL}Countries?term=&_=${date}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_GET_CITIES](context, payload) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Get(`${context.rootState.API_URL}Cities?countryKey=${payload}&term=&_=${date}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_GET_CAPTCHA](context) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Get(`${context.rootState.API_ORIGIN}${context.rootState.PATH}/Account/GetSessionId?_=${date}`)
                .then(res => {

                    Get(`${context.rootState.API_URL}GetCaptcha?sessionId=${res.data}&_=${date}`)
                        .then(res2 => {
                            resolve({
                                sessionId: res.data,
                                src: `data:${res.data.ContentType};base64,${res2.data.FileContents}`
                            });
                        })
                })
        })
    },
    [types.A_CHECK_MAIL](context, payload) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Get(`${context.rootState.API_URL}CheckMail?mail=${payload}&_=${date}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_CHECK_CAPTCHA](context, payload) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Get(`${context.rootState.API_URL}CheckCaptcha?captchaText=${payload.captcha}&sessionId=${payload.sessionId}&_=${date}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_CHECK_REDIRECT_PERSONAL_ACCOUNT](context, code) {

        return new Promise((resolve) => {
            Get(`${context.rootState.API_URL}CheckRedirectPersonalAccount?dgCode=${code}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
};
